module.exports = __webpack_public_path__ + "img/thmb01_sp.a71e400c.jpg";